import { Link } from 'react-router-dom'
import { Zap } from 'lucide-react'
import { siteConfig } from '@/config/site.config'
import { useDynamicFooterMenu } from '@/client/hooks/useDynamicMenu'
import { MenuRenderer } from '@/client/components/shared/MenuRenderer'
import { FooterSkeleton } from '@/client/components/shared/NavigationSkeleton'

export function Footer() {
  const { items: footerGroups, isLoading } = useDynamicFooterMenu()

  return (
    <footer className="border-t border-border bg-muted/30">
      <div className="container mx-auto max-w-6xl px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 font-semibold text-lg mb-4">
              <Zap className="h-6 w-6 text-primary" />
              <span>{siteConfig.name}</span>
            </Link>
            <p className="text-sm text-muted-foreground">{siteConfig.description}</p>
          </div>

          {/* Dynamic Footer Link Groups */}
          {isLoading ? (
            <FooterSkeleton className="col-span-2 md:col-span-3" />
          ) : (
            <MenuRenderer
              items={footerGroups}
              variant="footer"
              className="col-span-2 md:col-span-3 grid grid-cols-2 md:grid-cols-3 gap-8"
            />
          )}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} {siteConfig.author.name}. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground">
            Built and operated by{' '}
            <a
              href="https://jezweb.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              Jezweb
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}
